import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IIdItemInfo } from '~src/ts/models/resourceInfoParts';

import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';

export type FlowWithRunPermission = IIdItemInfo & {
  name: string;
  userHasRunPermissions: boolean;
}

export type GetFlowsWithRunPermissionsParams = IGetItemsParams;

export type GetFlowsWithRunPermissionsResult = IGetItemsResult & {
  contents?: FlowWithRunPermission[];
}

export class GetFlowsWithRunPermissionsRequest extends Request<GetFlowsWithRunPermissionsParams, GetFlowsWithRunPermissionsResult> {
  constructor(params: GetFlowsWithRunPermissionsParams) {
    super('getFlowsWithRunPermissions', params);
  }
}
